import {
  chooseLocationText,
  invalidPostalCodeErrorText,
  manualStateAndCountryText,
  invalidCardNumberErrorText,
  invalidCvvErrorText,
  invalidCardDateErrorText,
  mustBeLoggedIn,
} from 'src/common/utils/form/paymentValidation';
import RecurlyValidationErrors from './recurlyValidationErrors';

const ValidationMessages = [
  chooseLocationText,
  manualStateAndCountryText,
  invalidPostalCodeErrorText,
  invalidCardNumberErrorText,
  invalidCvvErrorText,
  invalidCardDateErrorText,
  mustBeLoggedIn,
].concat(RecurlyValidationErrors);

export default ValidationMessages;
